module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "date-range"
  }, [(_vm.showDate) ? _c('div', {
    staticClass: "dates"
  }, [_vm._v(_vm._s(_vm.dates))]) : _vm._e(), _vm._v(" "), (_vm.showTime) ? _c('div', {
    staticClass: "times"
  }, [_vm._v(_vm._s(_vm.times) + "\n    "), (_vm.showTimezone) ? _c('span', {
    staticClass: "timezone"
  }, [_vm._v("(" + _vm._s(_vm.timezoneAbbr) + ")")]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2fdc545a!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/atoms/date-range/date-range.vue
// module id = 641
// module chunks = 4